const index = () => import(/* webpackChunkName: "home" */ '../pages/index.vue');
const adver = () => import(/* webpackChunkName: "adver" */ '../pages/adver.vue');
const list = () => import(/* webpackChunkName: "list" */ '../pages/list.vue');
const search = () => import(/* webpackChunkName: "search" */ '../pages/search.vue');
const articledetail = () => import(/* webpackChunkName: "articledetail" */ '../pages/articledetail.vue');
const photos = () => import(/* webpackChunkName: "photos" */ '../pages/photos.vue');
const team = () => import(/* webpackChunkName: "team" */ '../pages/team.vue');
const department = () => import(/* webpackChunkName: "department" */ '../pages/department.vue');

export default [
  { path: '/', component: index, meta: { requireAuth: false } },
  { path: '/list', component: list, meta: { requireAuth: false } },
  { path: '/search', component: search, meta: { requireAuth: false } },
  { path: '/archive', component: articledetail, meta: { requireAuth: false } },
  { path: '/piclist', component: photos, meta: { requireAuth: false } },
  { path: '/team', component: team, meta: { requireAuth: false } },
  { path: '/deptlist', component: department, meta: { requireAuth: false } },
  { path: '/adver', component: adver, meta: { requireAuth: false } },



];



// WEBPACK FOOTER //
// ./src/router/router.js